import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({}))

/* Types */
export const ACTION_SEARCH_REGULATORY_BODY = 'ACTION_SEARCH_REGULATORY_BODY'

export const ACTION_GET_REGULATORY_BODY = 'ACTION_GET_REGULATORY_BODY'

export const ACTION_DELETE_REGULATORY_BODY = 'ACTION_DELETE_REGULATORY_BODY'

export const ACTION_UPDATE_REGULATORY_BODY = 'ACTION_UPDATE_REGULATORY_BODY'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {

		case ACTION_SEARCH_REGULATORY_BODY:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_GET_REGULATORY_BODY:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_DELETE_REGULATORY_BODY:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_UPDATE_REGULATORY_BODY:
			return state.set('Response', new Immutable.Map(action.Obj))
		default:
			return state
	}
}

/* Action Creators */

export const addRegulatoryBody = (form) => {

	let contactos = contactos = form.contactos.map(contacto => {
		if (contacto.tmp) {
			delete contacto.id
			delete contacto.tmp
			delete contacto.name
		}
		return contacto
	})

	let temp = {
		presidente: 1,
		comentarios: form.commentaries,
		contactos: contactos,
		createdBy: sessionStorage.uid,
		deleted: form.status === 1 ? false : true,
		documentos: [],
		domicilioCorrespondencia: {
			calle: !form.toggle ? form.street : form.streetCorrespondencia,
			entreCalle1: !form.toggle ? form.bstreet1 : form.bstreet1Correspondencia,
			entreCalle2: !form.toggle ? form.bstreet2 : form.bstreet2Correspondencia,
			idCiudad: !form.toggle ? form.city : form.cityCorrespondencia,
			idCodigoPostal: !form.toggle ? form.cp : form.cpCorrespondencia,
			idColonia: !form.toggle ? form.colony : form.colonyCorrespondencia,
			idEstado: !form.toggle ? form.state : form.stateCorrespondencia,
			idMunicipioDelegacion: !form.toggle ? form.town : form.townCorrespondencia,
			numeroExterior: !form.toggle ? form.numext : form.numextCorrespondencia,
			numeroInterior: !form.toggle ? form.numint : form.numintCorrespondencia,
			referencia: !form.toggle ? form.reference : form.referenceCorrespondencia,
			tipoDomicilio: "Correspondencia",
			deleted: false
		},
		domicilioCorrespondenciaNoEsMismo: form.toggle ? true : false,
		domicilioFiscal: {
			calle: form.street,
			entreCalle1: form.bstreet1,
			entreCalle2: form.bstreet2,
			idCiudad: form.city,
			idCodigoPostal: form.cp,
			idColonia: form.colony,
			idEstado: form.state,
			idMunicipioDelegacion: form.town,
			numeroExterior: form.numext,
			numeroInterior: form.numint,
			referencia: form.reference,
			tipoDomicilio: "Fiscal",
			deleted: false
		},
		email: form.mail,
		estatus: "1",
		extension: form.ext || "",
		lastModifiedBy: sessionStorage.uid,
		nombre: form.nombre,
		paginaWeb: form.website || "",
		siglas: form.acronym,
		telefono: form.telefono
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/addRegulatoryBody',
			method: "POST",
			data: temp,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const searchRegulatoryBody = (form) => {

	Utils.clearNullAndEmpty(form)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: Object.keys(form).length == 0 ? 'api/searchRegulatoryBody' : 'api/searchParamRegulatoryBody',
			method: "POST",
			data: form,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_REGULATORY_BODY, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getRegulatoryBody = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getRegulatoryBody',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			let data = response.data

			let domicilioFiscal = data.domicilioFiscal
			let domicilioCorrespondencia = data.domicilioCorrespondencia
			let domicilioCorrespondenciaNoEsMismo = data.domicilioCorrespondenciaNoEsMismo

			let contactos = []

			if (data.contactos !== null) {

				contactos = data.contactos.map((c) => {
					return {...c, name: `${c.nombre} ${c.apellidoPaterno} ${c.apellidoMaterno}`}
				})
			}

			let temp = {
				idOrganismoRegulador: data.id,
				nombre: data.nombre,
				acronym: data.siglas,
				status: !data.deleted ? 1 : 2,
				telefono: data.telefono,
				ext: data.extension,
				mail: data.email,
				website: data.paginaWeb,
				cp: domicilioFiscal.idCodigoPostal,
				state: domicilioFiscal.idEstado,
				town: domicilioFiscal.idMunicipioDelegacion,
				city: domicilioFiscal.idCiudad,
				colony: domicilioFiscal.idColonia,
				street: domicilioFiscal.calle,
				numext: domicilioFiscal.numeroExterior,
				numint: domicilioFiscal.numeroInterior,
				bstreet1: domicilioFiscal.entreCalle1,
				bstreet2: domicilioFiscal.entreCalle2,
				reference: domicilioFiscal.referencia,
				toggle: domicilioCorrespondenciaNoEsMismo,
				cpCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idCodigoPostal : "",
				stateCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idEstado : "",
				townCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idMunicipioDelegacion : "",
				cityCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idCiudad : "",
				colonyCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.idColonia : "",
				streetCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.calle : "",
				numextCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.numeroExterior : "",
				numintCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.numeroInterior : "",
				bstreet1Correspondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.entreCalle1 : "",
				bstreet2Correspondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.entreCalle2 : "",
				referenceCorrespondencia: domicilioCorrespondenciaNoEsMismo ? domicilioCorrespondencia.referencia : "",
				commentaries: data.comentarios,
				contactos: contactos
			}

			dispatch({ type: ACTION_GET_REGULATORY_BODY, Obj: temp })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateRegulatoryBody = (form) => {

	let data = Object.assign({}, form)
	data.contactos = data.contactos.map(contacto => {
		if (contacto.tmp) {
			delete contacto.id
			delete contacto.tmp
		}
		return contacto
	})
	data.contactos = Utils.unionArray(data.contactos, data.contactosRemove)

	let contactos = data.contactos.map((c) => {
		delete c.name
		return {...c }
	})

	let temp = {
		id: data.idOrganismoRegulador,
		presidente: 1,
		comentarios: data.commentaries,
		contactos: contactos,
		createdBy: sessionStorage.uid,
		deleted: data.status === 1 ? false : true,
		documentos: [],
		domicilioCorrespondencia: {
			calle: !data.toggle ? data.street : data.streetCorrespondencia,
			entreCalle1: !data.toggle ? data.bstreet1 : data.bstreet1Correspondencia,
			entreCalle2: !data.toggle ? data.bstreet2 : data.bstreet2Correspondencia,
			idCiudad: !data.toggle ? data.city : data.cityCorrespondencia,
			idCodigoPostal: !data.toggle ? data.cp : data.cpCorrespondencia,
			idColonia: !data.toggle ? data.colony : data.colonyCorrespondencia,
			idEstado: !data.toggle ? data.state : data.stateCorrespondencia,
			idMunicipioDelegacion: !data.toggle ? data.town : data.townCorrespondencia,
			numeroExterior: !data.toggle ? data.numext : data.numextCorrespondencia,
			numeroInterior: !data.toggle ? data.numint : data.numintCorrespondencia,
			referencia: !data.toggle ? data.reference : data.referenceCorrespondencia,
			tipoDomicilio: "Correspondencia",
			deleted: false
		},
		domicilioCorrespondenciaNoEsMismo: data.toggle ? true : false,
		domicilioFiscal: {
			calle: data.street,
			entreCalle1: data.bstreet1,
			entreCalle2: data.bstreet2,
			idCiudad: data.city,
			idCodigoPostal: data.cp,
			idColonia: data.colony,
			idEstado: data.state,
			idMunicipioDelegacion: data.town,
			numeroExterior: data.numext,
			numeroInterior: data.numint,
			referencia: data.reference,
			tipoDomicilio: "Fiscal",
			deleted: false
		},
		email: data.mail,
		estatus: "1",
		extension: data.ext || "",
		lastModifiedBy: sessionStorage.uid,
		nombre: data.nombre,
		paginaWeb: data.website || "",
		siglas: data.acronym,
		telefono: data.telefono
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/updateRegulatoryBody',
			method: "POST",
			data: temp,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const deleteRegulatoryBody = () => {
	return (dispatch) => {
		return dispatch({ type: ACTION_DELETE_REGULATORY_BODY, Obj: {code: '', message: ''} })
	}
}

export const clearRegulatoryBody = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_REGULATORY_BODY, Obj: {} })
		dispatch({ type: ACTION_SEARCH_REGULATORY_BODY, Obj: []})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Configurations/RegulatoryBody/index.js